<template>
  <div v-if="data" class="car-detail">
    <div class="car-detail-container">
      <div class="car-price-mobile" v-show="data.SaleActive">
        <h3>Cena</h3>
        <DetailRow title :data="data.Price" extClass="price" />
        <DetailRow
          v-if="data.PriceWithoutVAT != 0"
          title
          :data="data.PriceWithoutVAT"
          extClass="price-vat"
        />
      </div>
      <div class="car-data">
        <h3>Popis vozu</h3>
        <DetailRow title="Počet zobrazení" :data="data.ViewCount" />
        <DetailRow title="Karoserie" :data="data.Body" extClass="alternate" />
        <DetailRow title="Barva" :data="data.Color" />
        <DetailRow title="Palivo" :data="data.FuelType" extClass="alternate" />
        <DetailRow title="Objem" :data="data.Objem" />
        <DetailRow title="Výkon" :data="data.Power" extClass="alternate" />
        <DetailRow title="Stav km" :data="data.Km" />
        <DetailRow title="Rok výroby" :data="data.ManufactureYear" extClass="alternate" />
        <DetailRow title="V provozu od" :data="data.ProvozOd" />
        <DetailRow title="Stav vozu" :data="data.CarCondition" extClass="alternate" />
        <DetailRow title="Původ" :data="data.Origin" />
        <DetailRow title="Počet sedadel" :data="data.SeatsCount" extClass="alternate" />
        <DetailRow title="První majitel" :data="data.FirstOwner" />
        <DetailRow title="Servisní knížka" :data="data.ServiceBook" extClass="alternate" />
        <DetailRow title="Vybavení" :data="data.Equipment" />
      </div>
      <div class="car-data-extended">
        <div class="car-image">
          <h3>Galerie</h3>
          <div class="carousel">
            <v-carousel
              :continuous="true"
              :cycle="true"
              height="100%"
              interval="4000"
              :show-arrows="false"
              dark
            >
              <v-carousel-item
                v-for="(img, i) in this.data.Pictures.slice(0, 8)"
                :key="i"
                reverse-transition="slide-x-reverse-transition"
                transition="slide-x-transition"
                @click="getCarousel(i)"
              >
                <img :src="img.Src" class="image" />
              </v-carousel-item>
            </v-carousel>
          </div>
        </div>
        <div class="car-price" v-show="data.SaleActive">
          <h3>Cena</h3>
          <DetailRow title :data="data.Price" extClass="price" />
          <DetailRow
            v-if="data.PriceWithoutVAT != 0"
            title
            :data="data.PriceWithoutVAT"
            extClass="price-vat"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DetailRow from "./components/DetailRow";

export default {
  components: {
    DetailRow
  },
  props: ["data"],
  mounted() {
    this.$vuetify.theme.themes.dark.primary = "#4caf50";
  },
  computed: {
    getPictures() {
      var images = this.data.Pictures.map(p => p.Src);
      return images;
    }
  },
  methods: {
    getCarousel(index) {
      this.$emit("getCarousel", index);
    }
  },
  filters: {
    capitalize(value) {
      if (!value) return "";
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../scss/global.scss";
.car-detail {
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-items: center;

  h3 {
    text-align: left;
    margin: 0.2rem 0;
  }

  .car-detail-container {
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    align-content: center;
    justify-items: center;
    .car-data {
      position: relative;
      margin-top: 2.3rem;
    }
    .car-price-mobile {
      width: 100%;
      padding-top: 0;
      display: block;
    }
    .car-data-extended {
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      .car-image {
        width: 100%;
        overflow: hidden;
        .carousel {
          width: 100%;
          height: 15rem;
          margin: 0 auto;
          cursor: pointer;
          .image {
            width: 100%;
            height: 100%;
          }
        }
      }
      .car-price {
        width: 100%;
        padding-top: 0;
        display: none;
      }
    }
  }

  @media (min-width: 40rem) {
    .car-detail-container {
      .car-data-extended {
        .car-image {
          .carousel {
            width: 70%;
          }
        }
      }
    }
  }

  @media (min-width: $min-width-extended) {
    .car-detail-container {
      flex-direction: row;
      justify-content: space-between;
      justify-items: flex-start;
      min-height: 17rem;
      overflow-y: auto;
      overflow-x: hidden;
      .car-data {
        margin-top: 1rem;
        width: 100%;
      }
      .car-price-mobile {
        display: none;
      }
      .car-data-extended {
        width: 500px;
        flex-direction: column;
        padding-left: 2rem;
        .car-image {
          .carousel {
            width: 30rem;
            height: 20rem;
          }
        }
        .car-price {
          display: block;
        }
      }
    }
  }
}
</style>
